"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const useDevice_1 = require("../hooks/useDevice");
const colors_1 = require("../common/colors");
const AppText_1 = require("../component/AppText");
const GradientButton_1 = require("../component/GradientButton");
const SheetCloseButton_1 = __importDefault(require("../component/AppButton/SheetCloseButton"));
const useAppQuota_1 = require("../hooks/useAppQuota");
const AppTooltip_1 = __importDefault(require("../component/AppTooltip"));
const rootNavigation_1 = require("./rootNavigation");
const react_redux_1 = require("react-redux");
const formatNumber = (num) => {
    if (num >= 1000000)
        return `${(num / 1000000).toFixed(1)}m`;
    if (num >= 1000)
        return `${(num / 1000).toFixed(1)}k`;
    return num.toString();
};
const CreditCounter = () => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const { deviceWidth, deviceHeight, isMobileScreen } = (0, useDevice_1.useDevice)();
    const { characterQuota, pendingMessageCount } = (0, useAppQuota_1.useAppQuota)();
    const [animation] = (0, react_1.useState)(new react_native_1.Animated.Value(0));
    const [showMessages, setShowMessages] = (0, react_1.useState)(true);
    const rotateAnimation = (0, react_1.useState)(new react_native_1.Animated.Value(0))[0];
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    (0, react_1.useEffect)(() => {
        if (isHovered) {
            react_native_1.Animated.sequence([
                react_native_1.Animated.timing(rotateAnimation, {
                    toValue: 1,
                    duration: 250,
                    useNativeDriver: true,
                })
            ]).start(() => {
                setShowMessages(true);
            });
        }
        else {
            // Reset to show summaries when not hovered
            setShowMessages(false);
            rotateAnimation.setValue(0);
        }
    }, [isHovered]);
    const handleOpen = (0, react_1.useCallback)(() => {
        if (isOpen && !isMobileScreen) {
            handleClose();
            return;
        }
        setIsOpen(true);
        if (!isMobileScreen) {
            react_native_1.Animated.spring(animation, {
                toValue: 1,
                useNativeDriver: true,
            }).start();
        }
    }, [isMobileScreen, isOpen]);
    const handleNavigatePlans = () => {
        (0, rootNavigation_1.navigate)(fbUser?.uid ? "PurchasePlans" : "LoginPage");
        handleClose();
    };
    const handleClose = (0, react_1.useCallback)(() => {
        if (isMobileScreen) {
            setIsOpen(false);
        }
        else {
            react_native_1.Animated.spring(animation, {
                toValue: 0,
                useNativeDriver: true,
            }).start(() => setIsOpen(false));
        }
    }, [isMobileScreen]);
    const renderContent = () => ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.content, children: [isMobileScreen && ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.header, children: "Your Balance" })), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.statusContainer, children: [(0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: `${formatNumber(pendingMessageCount)} messages remaining`, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.statusItem, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faMessageDots, size: 20, color: colors_1.Colors.PRIMARY_300 }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.statusText, children: formatNumber(pendingMessageCount) })] }) }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.plusText, children: "+" }), (0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: `${formatNumber(characterQuota?.quota ? characterQuota.quota - characterQuota.consumed : 0)} summaries remaining`, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.statusItem, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSparkles, size: 20, color: colors_1.Colors.SUCCESS }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.statusText, children: formatNumber(characterQuota?.quota ? characterQuota.quota - characterQuota.consumed : 0) })] }) })] }), (0, jsx_runtime_1.jsx)(GradientButton_1.GradientButton, { text: "Buy More", onPress: handleNavigatePlans, fullWidth: false, style: { minWidth: isMobileScreen ? deviceWidth - 40 : 256 } })] }));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: `${formatNumber(pendingMessageCount)} messages and ${formatNumber(characterQuota?.quota ? characterQuota.quota - characterQuota.consumed : 0)} summaries remaining`, openDelay: 500, children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: handleOpen, onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [
                            styles.buttonContainer,
                            isHovered && styles.buttonContainerHover
                        ], children: [(0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: {
                                    transform: [{
                                            rotateY: rotateAnimation.interpolate({
                                                inputRange: [0, 1],
                                                outputRange: ['0deg', '180deg']
                                            })
                                        }]
                                }, children: showMessages ? ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faMessageDots, size: 20, color: colors_1.Colors.PRIMARY_300 })) : ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSparkles, size: 20, color: colors_1.Colors.SUCCESS })) }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.creditCount, children: showMessages ? formatNumber(pendingMessageCount) : formatNumber(characterQuota?.quota ? characterQuota.quota - characterQuota.consumed : 0) })] }) }) }), isMobileScreen ? ((0, jsx_runtime_1.jsx)(native_base_1.Actionsheet, { isOpen: isOpen, onClose: handleClose, hideDragIndicator: true, children: (0, jsx_runtime_1.jsxs)(native_base_1.Actionsheet.Content, { style: [styles.sheet, {
                            minHeight: deviceHeight * 0.3,
                        }], bg: colors_1.Colors.DARK_700, children: [(0, jsx_runtime_1.jsx)(SheetCloseButton_1.default, { onClose: handleClose }), renderContent()] }) })) : isOpen && ((0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: [
                    styles.webSheet,
                    {
                        transform: [{
                                translateY: animation.interpolate({
                                    inputRange: [0, 1],
                                    outputRange: [50, 0]
                                })
                            }],
                        opacity: animation
                    }
                ], children: renderContent() }))] }));
};
const styles = react_native_1.StyleSheet.create({
    buttonContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: colors_1.Colors.DARK_600,
        padding: 8,
        borderRadius: 12,
        gap: 8,
        transition: 'all 0.2s ease-in-out',
    },
    buttonContainerHover: {
        backgroundColor: colors_1.Colors.DARK_500,
        transform: [{ scale: 1.05 }],
    },
    creditCount: {
        color: colors_1.Colors.white,
        fontSize: 16,
        fontWeight: '500',
    },
    sheet: {
        width: '100%',
        padding: 24,
        paddingTop: 48,
    },
    webSheet: {
        position: 'absolute',
        top: 60,
        right: 0,
        backgroundColor: colors_1.Colors.DARK_600,
        borderRadius: 12,
        padding: 24,
        width: 320,
        shadowColor: '#000',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 3.84,
        elevation: 5,
    },
    content: {
        width: '100%',
        gap: 24,
        alignItems: 'center',
    },
    statusContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
    },
    statusItem: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    statusText: {
        color: colors_1.Colors.white,
        fontSize: 16,
        fontWeight: '500',
    },
    plusText: {
        color: colors_1.Colors.white,
        fontSize: 16,
        fontWeight: '500',
    },
    header: {
        color: colors_1.Colors.white,
        fontSize: 20,
        fontWeight: '600',
    },
});
exports.default = CreditCounter;
